
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {FirebaseDB} from "../../FirebaseDB"
import AdComponent from './AdComponent';

// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";

import { withTranslation } from 'react-i18next';

class HowtoCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login
    }

    this.previousWidth = -1;
  }

  render() {

    const { t } = this.props;

    return (
      <Container fluid className={classNames('content', { 'is-open': this.props.isOpen })}>
        {/* <NavBar toggle={this.props.toggle} /> */}

        {/* <LoginContext.login></LoginContext.login> */}


        <h3>{t("youtube")} </h3>

        <a href='https://www.youtube.com/watch?v=OQ2wywXTbd4' target="_blank" >

          youtube tutorial link
          </a>
        <p>
          </p>
          
        <h3>{t("start_cctv_mode")}</h3>
        
        <h5>{t("click_cctv_mode")}</h5>
        <h5>{t("select_recording")}</h5>
        <h5>{t("click_cctv_start")}</h5>
        
        <img style={{ margin : 20}} height="360" width="164"  src='./img/howto1.jpg'/>
        <img style={{ margin : 20}} height="360" width="164"  src='./img/howto2-1.jpg'/>
        <img style={{ margin : 20}} height="360" width="164"  src='./img/howto2-2.jpg'/>

        <h3>{t("share")}</h3>

        <h5>{t("click_share")}</h5>
        <h5>{t("copy_url")}</h5>
        <h5>{t("connecting")}</h5>

        
        <img style={{ margin : 20}} height="360" width="164"  src='./img/howto3.jpg'/>
        <img style={{ margin : 20}} height="360" width="164"  src='./img/howto3-1.jpg'/>
        <img style={{ margin : 20}} height="360" width="360"  src='./img/features1-2.png'/>

      

      </Container>

      
    );
  }
}




export default withTranslation()(HowtoCom);
